import React, { useMemo } from 'react';

import { Flex, Modal } from 'src/packages/core';
import { KycSettings, QuickSearchDataType } from '../Header.types';
import { DarkTheme, LightTheme, ThemeType, useTheme } from 'src/packages/theme';
import { SearchIconContent } from '../components/SearchIconContent';

interface LoggedUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  theme: ThemeType;
  quickSearchData: QuickSearchDataType;
  kycSettings?: KycSettings;
}

export const QuickSearchModal = ({
  isOpen,
  onClose,
  quickSearchData,
  theme,
  kycSettings,
}: LoggedUserModalProps) => {
  const contextTheme = useTheme();

  const defaultTheme = useMemo(() => {
    return theme
      ? theme === 'light'
        ? { ...LightTheme, rtl: contextTheme.rtl }
        : { ...DarkTheme, rtl: contextTheme.rtl }
      : contextTheme;
  }, [contextTheme, theme]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='full-screen'
      height={'100%'}
      backdropBgColor={defaultTheme.colors.background.secondary.BG3}
      backgroundColor={defaultTheme.colors.background.secondary.BG3}
    >
      <Flex
        position={'absolute'}
        top={'52px'}
        width={'100%'}
        left={'0'}
        right={'0'}
        borderTop={`1px solid ${defaultTheme.colors.border.darker}`}
      >
        <SearchIconContent
          quickSearchData={quickSearchData}
          theme={theme}
          kycSettings={kycSettings}
        />
      </Flex>
    </Modal>
  );
};
